module.exports = __webpack_public_path__ + "static/media/1.c3b62b4d.png";